import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Spinner } from '@/components/ui/spinner';

interface SuperuserRouteProps {
  children: React.ReactNode;
}

export function SuperuserRoute({ children }: SuperuserRouteProps) {
  const { isAuthenticated, isSuperuser, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isSuperuser) {
    return <Navigate to="/media-gallery" replace />;
  }

  return <>{children}</>;
}
